// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._1bsb1osq{width:100%}\n._c71l1kw7{max-height:inherit}\n._kqswh2mm{position:relative}\n@keyframes rotationAnimation{0%{--gradient-angle:0deg}to{--gradient-angle:360deg}}\n@property --gradient-angle{syntax:\"<angle>\";initial-value:270deg;inherits:false}", ""]);
// Exports
module.exports = exports;
